const PLAY_ICON = `
<svg
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">

    <circle
        cx="32"
        cy="32"
        r="32"
        fill="rgba(0,0,0,.75)" />

    <path
        d="M25 20L46 32L25 44V20Z"
        fill="white" />

</svg>
`

document.addEventListener('DOMContentLoaded', async () => {

    try {

        const response =
            await fetch(
                window.LANDING_VIDEOS_URL
            )

        window.LANDING_VIDEOS =
            await response.json()

    } catch (error) {

        console.error(
            'Error loading videos',
            error
        )

        return
    }

    const tabsContainer = document.getElementById('videoTabs')
    const gridContainer = document.getElementById('videoGrid')

    const modal = document.getElementById('videoModal')
    const modalTitle = document.getElementById('modalTitle')
    const modalBody = document.getElementById('modalBody')

    const closeButton = document.getElementById('closeModal')

    const categories = [
        'Todos',
        ...new Set(
            window.LANDING_VIDEOS.map(
                video => video.categoria
            )
        )
    ]

    let activeCategory = 'Todos'

    const HIDDEN_IN_ALL = [
        29,
        30,
        31,
        33,
        34,
        35,
        36,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        50,
        51,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        71,
        72,
        74,
        75,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        98,
        99,
        103,
        105,
        110,
        111,
    ]

    function youtubeEmbedUrl(url) {

        const regex =
            /(?:youtu\.be\/|youtube\.com\/watch\?v=)([^&]+)/

        const match = url.match(regex)

        if (!match) {
            return ''
        }

        return `https://www.youtube.com/embed/${match[1]}`
    }

    function openModal(video) {

        modalTitle.textContent = video.titulo

        modalBody.innerHTML = `
            <iframe
                src="${youtubeEmbedUrl(video.youtubeUrl)}"
                allowfullscreen>
            </iframe>
        `

        modal.hidden = false

        document.body.style.overflow = 'hidden'
    }

    function closeModal() {

        modal.hidden = true

        modalBody.innerHTML = ''

        document.body.style.overflow = ''
    }

    function renderTabs() {

        tabsContainer.innerHTML = categories
            .map(category => `
                <button
                    class="video-tab ${category === activeCategory ? 'video-tab--active' : ''}"
                    data-category="${category}">
                    ${category}
                </button>
            `)
            .join('')
    }

    function getImageUrl(video) {

        const imageName =
            video.image ||
            `landing-videos-${video.id}.jpg`

        return window.LANDING_VIDEO_ASSET_BASE.replace(
            'landing-videos-1.jpg',
            imageName
        )

    }

    function renderCards() {

        let filtered =
            activeCategory === 'Todos'
                ? window.LANDING_VIDEOS
                : window.LANDING_VIDEOS.filter(
                    video =>
                        video.categoria === activeCategory
                )

                if (activeCategory === 'Todos') {
                    filtered = filtered.filter(
                        video => !HIDDEN_IN_ALL.includes(video.id)
                    )
                }

        gridContainer.innerHTML = filtered
            .map(video => {

                return `
                    <article class="video-card">

                        <button
                            class="video-card__thumbnail"
                            data-video-id="${video.id}">

                            <img
                                class="video-card__image"
                                src="${getImageUrl(video)}"
                                alt="${video.titulo}">

                            <span
                                class="video-card__play">

                                ${PLAY_ICON}

                            </span>

                        </button>

                        <div class="video-card__content">

                            <h3 class="video-card__title">
                                ${video.titulo}
                            </h3>

                            <h4 class="video-card__model">
                                ${video.modelo}
                            </h4>

                            <a
                                class="video-card__link"
                                href="${video.youtubeUrl}"
                                target="_blank"
                                rel="noopener noreferrer">

                                Ver en Youtube

                            </a>

                        </div>

                    </article>
                `
            })
            .join('')
    }

    tabsContainer.addEventListener(
        'click',
        event => {

            const button =
                event.target.closest(
                    '.video-tab'
                )

            if (!button) return

            activeCategory =
                button.dataset.category

            renderTabs()
            renderCards()
        }
    )

    gridContainer.addEventListener(
        'click',
        event => {

            const trigger =
                event.target.closest(
                    '.video-card__thumbnail'
                )

            if (!trigger) return

            const id =
                Number(
                    trigger.dataset.videoId
                )

            const video =
                window.LANDING_VIDEOS.find(
                    item => item.id === id
                )

            if (!video) return

            openModal(video)
        }
    )

    closeButton.addEventListener(
        'click',
        closeModal
    )

    modal.addEventListener(
        'click',
        event => {

            if (
                event.target.hasAttribute(
                    'data-close-modal'
                )
            ) {
                closeModal()
            }
        }
    )

    document.addEventListener(
        'keydown',
        event => {

            if (
                event.key === 'Escape' &&
                !modal.hidden
            ) {
                closeModal()
            }
        }
    )

    renderTabs()
    renderCards()
})